import React from "react";

import "./IconTableHeader.scss";

interface IconTableHeaderProps {
  tableButton?: React.ReactNode;
  tableHeader?: string;
  tableCountLabel?: string;
  tableCount?: string | number;
}

const IconTableHeader = ({
  tableButton,
  tableHeader,
  tableCountLabel,
  tableCount,
}: IconTableHeaderProps) => {
  return (
    <div className="icon-table-header">
      <span className="table-count">
        <p className="table-header">{tableHeader}:</p>
        {tableCountLabel && (
          <p className="table-count-label">{tableCountLabel}</p>
        )}
        {tableCount && <p className="count">({tableCount})</p>}
      </span>
      <span>{tableButton && <span>{tableButton}</span>}</span>
    </div>
  );
};

export default IconTableHeader;
